
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2026-04-20-be-a-builder",
      function () {
        return require("private-next-pages/posts/2026-04-20-be-a-builder.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2026-04-20-be-a-builder"])
      });
    }
  